export default __webpack_public_path__ + "static/media/grid8.3b4d2282.png";